import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoAz: CultureInfo = {
  name: 'az',
  displayName: 'Azerbaijani',
  iso3LanguageCode: 'aze',
  iso2LanguageCode: 'az',
  ietfLanguageTag: 'az',
  parent: null
};
